import React from 'react'
import styled from 'styled-components'

import { Helmet } from 'react-helmet'
import { NavLink as RouterNavLink, NavLinkProps } from 'react-router-dom'
import {
  Breadcrumbs as MuiBreadcrumbs,
  Divider as MuiDivider,
  Grid,
  Link,
  Typography,
} from '@material-ui/core'
import { spacing } from '@material-ui/system'

import {
  useQueryPaginator,
  RelatedLinkedField,
  PaginatedTable,
  ValueField,
} from 'src/components/Table'

import { skuit } from 'src/services/skuit'

const NavLink = React.forwardRef((props: NavLinkProps, ref: React.Ref<HTMLAnchorElement>) => (
  <RouterNavLink innerRef={ref} {...props} />
))
NavLink.displayName = 'NavLink'

const Divider = styled(MuiDivider)(spacing)

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing)

export const PickingPage = () => {
  const paginator = useQueryPaginator(
    'order-unit-list',
    skuit.sc.picking.skus.list
  )

  return (
    <React.Fragment>
      <Helmet title="Picking" />

      <Grid justify="space-between" container spacing={10}>
        <Grid item>
          <Typography variant="h3" gutterBottom display="inline">
            Orders
          </Typography>

          <Breadcrumbs aria-label="Breadcrumb" mt={2}>
            <Link component={NavLink} exact to="/">
              Dashboard
            </Link>
            <Typography>Picking</Typography>
          </Breadcrumbs>
        </Grid>
      </Grid>

      <Divider my={6} />

      <Grid container spacing={6}>
        <Grid item xs={12}>
          <PaginatedTable
            title="SKUs in orders"
            fields={[
              { id: 'product', label: 'Product', renderer: RelatedLinkedField(ValueField, 'name') },
              { id: 'sku', label: 'Sku', renderer: RelatedLinkedField(ValueField, 'sku') },
              {
                id: 'sku.client',
                label: 'Client',
                renderer: RelatedLinkedField(ValueField, 'name'),
              },
              { id: 'numUnitsToPick', label: 'Number of Units to Pick', renderer: ValueField },
            ]}
            paginator={paginator}
          />
        </Grid>
      </Grid>
    </React.Fragment>
  )
}
